import { Button, Paper } from '@mui/material';
import { SimpleTreeView } from '@mui/x-tree-view';
import { MenuItem } from '../../../interfaces/Menu/MenuItem';
import { MenuItemTreeController } from './MenuItemTreeController';
import { MenuItemTreeNode } from './MenuItemTreeNode';
import { sharedStyles } from '../../../utils/Style';
import { getAllMenuItemIDs } from '../../../utils/Menu';

interface MenuItemTreeProps {
  menuItems: MenuItem[];
  selectedItem?: MenuItem;
  onAddRoot: () => void;
  onAddChild: (parentID: number, order: number) => void;
  onDelete: () => void;
  onSelect: (id: number) => void;
  onChangeOrder: (
    index: number,
    direction: 'up' | 'down',
    parentID?: number,
  ) => void;
}

export const MenuItemTree = (props: MenuItemTreeProps) => (
  <Paper sx={{ p: 3 }}>
    <MenuItemTreeController
      onAddChild={props.onAddChild}
      onDelete={props.onDelete}
      onChangeOrder={props.onChangeOrder}
    >
      <SimpleTreeView
        defaultExpandedItems={getAllMenuItemIDs(props.menuItems).map((id) =>
          id.toString(),
        )}
        selectedItems={props.selectedItem?.id.toString()}
        onSelectedItemsChange={(_, id) => props.onSelect(Number(id))}
      >
        {props.menuItems.map((menuItem, i) => (
          <MenuItemTreeNode
            key={menuItem.id}
            siblings={props.menuItems}
            index={i}
          />
        ))}
      </SimpleTreeView>
    </MenuItemTreeController>

    <Button onClick={props.onAddRoot} sx={{ ...sharedStyles.buttonText }}>
      + Öge Ekle
    </Button>
  </Paper>
);
